import React from "react";
import { healthTargetPath } from "../../Settings/constants";
import { PlanLink } from "../styles";
import { PLAN_STATUS_COLOR } from "./planMetrics";
import {
  PlanMetricItem as MetricItem,
  PlanMetricUnit,
  PlanMetricValue,
  PlanTargetDetail,
  PlanTargetRow,
  PlanTitle,
  PlanTitleRow,
  PlanUnitLine,
} from "./styles";
import { PlanMetricItemProps } from "./types";

export const PlanMetricItem: React.FC<PlanMetricItemProps> = ({
  title,
  metric,
  targetMetric,
  targetText,
  isTargetUnavailable,
  hint,
}) => {
  const titleId = `plan-${targetMetric}-title`;
  const isRunway = targetMetric === "runway" && metric.value !== null;
  const displayValue = isRunway
    ? metric.value?.toFixed(1)
    : metric.displayValue;
  const detailColor = PLAN_STATUS_COLOR[metric.status];
  let targetContent = (
    <>
      <span>No target</span>
      <PlanLink href={healthTargetPath(targetMetric)}>Set target →</PlanLink>
    </>
  );
  if (isTargetUnavailable) {
    targetContent = <span>Target unavailable</span>;
  } else if (targetText !== null) {
    const detail = metric.detail ?? "Awaiting data";
    targetContent = (
      <>
        <span>Target · {targetText}</span>
        <PlanTargetDetail $color={detailColor}>{detail}</PlanTargetDetail>
      </>
    );
  }

  return (
    <MetricItem
      aria-labelledby={titleId}
      data-testid={`plan-metric-${targetMetric}`}
    >
      <PlanTitleRow>
        <PlanTitle id={titleId}>{title}</PlanTitle>
        {hint}
      </PlanTitleRow>
      <PlanMetricValue>
        {displayValue}
        {isRunway && <PlanMetricUnit> months</PlanMetricUnit>}
      </PlanMetricValue>
      <PlanUnitLine>{metric.unitLine}</PlanUnitLine>
      <PlanTargetRow>{targetContent}</PlanTargetRow>
    </MetricItem>
  );
};
